"use strict";

/* globals define, app, socket, bootbox, ajaxify, RELATIVE_PATH, utils */

function drawFollow(){
	var uids = [];
	var uidsButtons = {};
	$('.categoriesBestUsersElem').each(function() {
		var tasto = $('.followBestUser', this);
		var uid = tasto.data('uid');
		if (uid) {
			uidsButtons[uid] = tasto;
			uids.push(uid);
		}
	});

	socket.emit('plugins.connectHomepage.stream.isFollowings', {uids: uids}, function(err, responseData) {
		Object.keys(responseData).forEach(r => {
			if (responseData[r]){
				uidsButtons[r].removeClass('plus');
			} else {
				uidsButtons[r].addClass('plus');
			}
		})
	});
}

define('forum/connect-homepage/stream', [
	'forum/connect-homepage/connect-homepage', 'components'
], function(connectHomepage, components) {
	$('.bestUsersFixedAddBtn').on('click', function(ev) {
		var el = $(this);
		var cid = el.data('cid');

		app.parseAndTranslate('connect-homepage/modals/stream-bestusersfixed', {}, function(tpl) {
			var modal = bootbox.dialog(
				{
					message:tpl,
					title:'Aggiungi Utente Fisso',
					size: 'large'
				}
			);
			modal.on('shown.bs.modal', function() {
				var timeoutId = 0;
				components.get('chat/search').on('keyup', function() {
					if (timeoutId) {
						clearTimeout(timeoutId);
						timeoutId = 0;
					}

					timeoutId = setTimeout(doSearch, 250);
				});
			});
		});
		ev.preventDefault();

		function doSearch() {
			var username = components.get('chat/search').val();
			var chatsListEl = $('[component="chat/search/list"]');

			if (!username) {
				return chatsListEl.empty();
			}

			socket.emit('user.search', {
				query: username,
				searchBy: 'username'
			}, function(err, data) {
				if (err) {
					return app.alertError(err.message);
				}

				displayResults(chatsListEl, data);
			});
		}

		function displayResults(chatsListEl, data) {
			chatsListEl.empty();

			if (!data.users.length) {
				return chatsListEl.translateHtml('<li><div><span>[[users:no-users-found]]</span></div></li>');
			}

			data.users.forEach(function(userObj) {
				var chatEl = displayUser(chatsListEl, userObj);
				onUserClick(chatEl, userObj);
			});
		}

		function displayUser(chatsListEl, userObj) {
			function createUserImage() {
				return (userObj.picture ?
					'<img src="' +	userObj.picture + '" title="' +	userObj.username +'" />' :
					'<div class="avatar  avatar-sm avatar-rounded" style="background-color: ' + userObj['icon:bgColor'] + '">' + userObj['icon:text'] + '</div>') +
					' '+ userObj.username;
			}

			var chatEl = $('<li component="chat/search/user" />')
					.attr('data-uid', userObj.uid)
					.appendTo(chatsListEl);

			chatEl.append(createUserImage());
			return chatEl;
		}

		function onUserClick(chatEl, userObj) {
			chatEl.on('click', function() {
				socket.emit('plugins.connectHomepage.stream.fixedUsersSave', {cid: cid, uid:userObj.uid}, function(err) {
					if(err) {
						app.alertError(err);
					} else {
						app.alertSuccess('Utente fissato con successo');
						window.location.reload();
					}
				});
			});
		}
		return false;
	});

	$('.bestUsersFixedDelBtn').on('click', function(ev) {
		var el = $(this);
		var cid = el.data('cid');
		var uid = el.data('uid');

		bootbox.confirm('Eliminare utente fissato nella categoria?', function(confirm) {
			if (confirm) {
				socket.emit('plugins.connectHomepage.stream.fixedUsersDelete', {cid: cid, uid:uid}, function(err, returnData) {
					if(err) {
						app.alertError(err);
					} else {
						app.alertSuccess('Utente rimosso con successo');
						window.location.reload();
					}
				});
			}
		});

		ev.preventDefault();
		return false;
	});
	//=====================

	return connectHomepage;
});

define('forum/connect-homepage/interest-expanded', [
	'forum/connect-homepage/connect-homepage'
], function(connectHomepage) {
	return connectHomepage;
});

define('forum/connect-homepage/interest-compressed', [
	'forum/connect-homepage/connect-homepage'
], function(connectHomepage) {
	return connectHomepage;
});

define('forum/account/profile', [
	'forum/connect-homepage/connect-homepage',
	'forum/account/header',
], function(connectHomepage, header) {
	var theirid;

	$(window).on('action:ajaxify.end', function(event, data) {
		if(data && data.url.startsWith('user/')) {
			connectHomepage.type = 'profile';
			connectHomepage.view = 'timeline';
		}
	});

	connectHomepage.initFunction = function() {
		header.init();

		connectHomepage.theirid = theirid = ajaxify.data.theirid;

		//app.enterRoom('user/' + theirid);

		socket.removeListener('event:user_status_change', onUserStatusChange);
		socket.on('event:user_status_change', onUserStatusChange);
	};
	function onUserStatusChange(data) {
		if (parseInt(ajaxify.data.theirid, 10) !== parseInt(data.uid, 10)) {
			return;
		}

		app.updateUserStatus($('.account [data-uid="' + data.uid + '"] [component="user/status"]'), data.status);
	}
	return connectHomepage;
});

define('forum/connect-homepage/connect-homepage', [
	'forum/infinitescroll',
	'forum/topic/threadTools',
	'forum/connect-homepage/postTools',
	'forum/topic/events',
	'forum/topic/posts',
	'components',
	'translator',
	'composer',
	'benchpress',
	'helpers'
], function(infinitescroll, threadTools, postTools, events, posts, components, translator, composer, Benchpress, helpers) {
	var	connectHomepage = {},
		currentUrl = '';

	connectHomepage.init = function() {
		helpers.register();

		//---
		Benchpress.registerHelper('connectNumReplyMore', function(data) {
			var rest = parseInt(data) -4;
			var restTxt='';
			if(rest==1){
				 restTxt='<div class=" showMorePosts">Vedi 1 risposta precedente</div>';
			}else if(rest>1){
				restTxt='<div class=" showMorePosts">Vedi le altre '+rest+' risposte precedenti</div>';
			}
			return restTxt;
		});
		Benchpress.registerHelper('connectNumReply', function(data) {
			var rest = parseInt(data) -1;
			var restTxt='';
			if(rest==1){
				 restTxt='1 Risposta';
			}else if(rest>1){
				restTxt=rest+' Risposte';
			}
			return restTxt;
		});

		$('.followBestUser').on('click', function(ev) {
			var type = $(this).hasClass('plus') ? 'follow' : 'unfollow';
			var el = $(this);
			var uid = el.data('uid');
			var username = el.data('name');
			socket.emit('user.' + type, {uid: uid}, function(err) {
				if (err) {
					return app.alertError(err.message);
				}

				app.alertSuccess('[[global:alert.' + type + ', ' + username + ']]');
			});
			$(this).toggleClass('plus');
			drawFollow();
		});
		//---
		if($.isFunction(connectHomepage.initFunction)) {
			connectHomepage.initFunction();
		}
		app.enterRoom('connect_stream');
		events.init();

		components.get('topic').each(function(key, topic) {
			var tid = $(topic).data('tid');
			topicInit(tid);
		});



		$(window).on('action:ajaxify.end', function(event, data) {
			if(data && data.url=='interest') {
				connectHomepage.type = 'interest';
				connectHomepage.view = 'category';
			} else if (data && data.url=='interest-exp') {
				connectHomepage.type = 'interest';
				connectHomepage.view = 'timeline';
			} else if (data && data.url == "stream") {
				connectHomepage.type = "stream";
				connectHomepage.view = "timeline";
				drawFollow();
			}
		});


		$(window).trigger('action:topic.loaded', ajaxify.data);

		$(window).on('action:composer.submit', function (ev, data) {
			data.redirect = false;
		});

		/* Non so a cosa serve */
		socket.removeListener('event:connect_stream_topic_new', topicNew);
		socket.removeListener('event:connect_stream_topic_reply', topicReply);
		socket.on('event:connect_stream_topic_new', topicNew);
		socket.on('event:connect_stream_topic_reply', topicReply);
		/* Fine non so a cosa serve */

		filterButtonS = document.getElementsByClassName("categoriesFilter")

		

		for (var i=0;i<filterButtonS.length; i++) {
			filterButton = filterButtonS[i];
			filterButton.addEventListener('click', function(ev) {
				if (filterButton.dataset.mode == "stream") {
					var mode = "streamCategories";
					var title = "Escludi dallo stream le categorie:";
				} else {
					var mode = "interestCategories";
					var title = "Includi nell\'interest le categorie:";
				}
				socket.emit('categories.getCategoriesByPrivilege', 'find', function(err, categoriesUnordered) {
					if (err) {
						return app.alertError('Errore durante il caricamento delle categorie, riprova');
					}
					socket.emit('plugins.connectHomepage.homepage.getCategories', 'find', function(err, settings) {
						if (err) {
							return app.alertError('Error loading data 3754, try again');
						}

						categoriesUnordered.forEach(category => {
							if (settings[mode].indexOf(category.cid) === -1){
								category.isChecked = true
							}
						})

						socket.emit('plugins.connectHomepage.homepage.treeCategories', {categories:categoriesUnordered, parentCid:0}, function(err, categories) {
							
							if (mode == "streamCategories") {
								Benchpress.registerHelper('ConnectHomepageFilterCheckbox', function(data) {
								    if(data && settings.streamCategories.indexOf(data.cid)===-1) {
								        return 'checked';
								    }
								    return '';
								});
							} else {
								Benchpress.registerHelper('ConnectHomepageFilterCheckbox', function(data) {
								    if(data && settings.interestCategories.indexOf(data.cid)!==-1) {
								        return 'checked';
								    }
								    return '';
								});
							}

							app.parseAndTranslate('connect-homepage/modals/filter', {categories:categories}, function(tpl) {
								var modal = bootbox.dialog({
									message: tpl,
									title: title,
									className: mode,
									size: 'large', 
									buttons: {
										success: {
											label: "Salva",
											className: "btn-primary save",
											callback: function() {
												if (mode == "streamCategories") {
													var checkboxCategoriesFrm = document.querySelectorAll("#filter_frm input[type=checkbox]:not(:checked)")
												} else {
													var checkboxCategoriesFrm = document.querySelectorAll("#filter_frm input[type=checkbox]:checked")
												}
												includedCategories = []
												checkboxCategoriesFrm.forEach( x => {
													includedCategories.push(parseInt(x.value))
											    })

												socket.emit('plugins.connectHomepage.homepage.saveCategories', {includedCategories:includedCategories, type:mode}, function(err, returnData) {
													if(err) {
														app.alertError(err);
													} else {
														app.alertSuccess(returnData.message);
														ajaxify.refresh();
													}
												});
											}
										}
									}
								})
								modal.on('shown.bs.modal', function() {
									document.querySelectorAll("#modalFilter input.mainCategory").forEach(category => {
										category.addEventListener("click", function() {
											var cid = category.value
											var isChecked = category.checked;
											document.querySelectorAll("#fcate" + cid + " input[type=checkbox]").forEach(v => {
												v.checked = isChecked;
											})
										})
									});
								});
							});
						});
					})
				});
			}) 
		}

		interestTop = document.querySelector(".connect-homepage-interest-top")
		if (interestTop) {
			interestTop.addEventListener('click', function() {
				socket.emit('plugins.connectHomepage.homepage.saveInterestTop', {interestTop:interestTop.checked}, function(err, returnData) {
					if(err) {
						app.alertError(err);
					} else {
						ajaxify.refresh();
					}
				});			
			})
		}

		$('.connect-homepage-interest-timefilter li a').on('click', function(ev) {
			var interestTimeFilter = $(this).data('value');
			var interestTimeFilter_text = $(this).html();
			socket.emit('plugins.connectHomepage.homepage.saveInterestTimeFilter', {interestTimeFilter:interestTimeFilter}, function(err, returnData) {
				if(err) {
					app.alertError(err);
				} else {
					$('.connect-homepage-interest-timefilter-value').html(interestTimeFilter_text);
					//app.alertSuccess(returnData.message);
					ajaxify.refresh();
				}
			});
			ev.preventDefault();
			return false;
		});
		// INTEREST MODE
		$('a.interestMode').on('click', function(ev) {
			var interestMode = $(this).data('mode');
			socket.emit('plugins.connectHomepage.homepage.saveInterestMode', {interestMode:interestMode}, function(err, returnData) {
				if(err) {
					app.alertError(err);
				} else {
					ajaxify.refresh();
				}
			});
			ev.preventDefault();
			return false;
		});
		// INTEREST MODE

		$('.connect-homepage-interest-timefilter').each(function() {
			var thisMain= this;
			var now = $(thisMain).find('.connect-homepage-interest-timefilter-value').data('value');
			$(thisMain).find('li a').each(function(){
				if(now === $(this).data('value')) {
					$(thisMain).find('.connect-homepage-interest-timefilter-value').html($(this).html());
				}
			});
		});

		handleInfiniteScroll();
	};

	function topicReply(data) {
		var tid = data.post.tid;
		var pid = data.post.pid;
		var uid = data.data.uid;
		socket.emit('plugins.connectHomepage.homepage.getNewTopicPrivilege', {tid:tid}, function(err, privileges) {
			data.topics = {}
			data.topics.privileges = privileges
			app.parseAndTranslate('connect-homepage/partials/post', {posts: data.post, topics: data.topics}, function(tpl) {	 
				var topicContainer = components.get('topic', 'tid', tid);
	        	topicContainer.find('.posts .post-stream .scroller').append(tpl);
	        	var postContainer = components.get('post', 'pid', pid);
	        	postContainer.find('.timeago').timeago();
	    	});	
		});
	}

	function handleInfiniteScroll() {
		var oldNext = 0;
		infinitescroll.init(function(direction) {
			if (direction < 0) {
				return;
			}
			var params = utils.params();
			next = document.querySelector("[data-next]")

			if (next.dataset.next != oldNext) {
				oldNext = next.dataset.next;
				infinitescroll.loadMore('plugins.connectHomepage.homepage.getMoreTopics', {
					type: connectHomepage.type,
					theirid: connectHomepage.theirid,
					after: next.dataset.next
				}, function(data, done) {
					loading = true;
					if (data.topics && data.topics.length) {						
						if(connectHomepage.view === 'category') {
							$(window).trigger('action:topics.loaded', {topics: data.topics});
							data.topics.forEach(topic => {
								app.parseAndTranslate('connect/partials/topic/topics_list_item', {topics:topic}, function(html) {
									$('[data-next]').attr('data-next', data.next);
									$('#category-no-topics').remove();
									$('[component="category"]').append(html);
									html.find('.timeago').timeago();
									app.createUserTooltips();
									utils.makeNumbersHumanReadable(html.find('.human-readable-number'));
									html.find('img').attr('data-state', 'loaded');
									done();
								});
							})
							$(window).trigger('action:ajaxify.end', data);
						} else {
							$(window).trigger('action:topics.loaded', {topics: data.topics});
							data.topics.forEach(topic => {
								app.parseAndTranslate('connect-homepage/partials/topic', {topics:topic}, function(html) {
									next.setAttribute('data-next', data.next);
									document.querySelector('.topics').append(html[0]);
									html.find('.timeago').timeago();
									topicInit(topic.tid);
									app.createUserTooltips();
									// utils.makeNumbersHumanReadable(html.find('.human-readable-number'));
									done();
								});
							})
							$(window).trigger('action:ajaxify.end', data);	
						}
					} else {
						$('#loaderConnect').hide();
						done();
					}
				});
			}
		});
	}

	function topicInit(tid) {
		postTools.init(tid);

		// =================================
		document.querySelectorAll(".postTextContent").forEach(post => {
			if(((post.offsetHeight > 200 && post.textContent.length > 550) || (post.offsetHeight > 800 && post.textContent.length > 250)) && !post.classList.contains("truncatedCont")){
				var emb = null;
				emb = post.querySelector('.embed-wrapper, iframe');
				var embhtml='';
				if(emb !=null && emb != undefined){
					embhtml= emb.outerHTML;
				}
				post.innerHTML = post.innerHTML.replace(/<p[^>]*>/g, '').replace(/<\/p>/g, '<br class="pReplaced" />');
				post.classList.add('truncatedCont', 'truncatedContShow');
				post.innerHTML = '<div class="truncEmb">'+embhtml+'</div><div class="truncated">'+post.innerHTML + '</div><a href="#" onclick="this.previousSibling.classList.remove(\'truncated\'); this.parentNode.classList.remove(\'truncatedContShow\'); this.style.display = \'none\'">altro</a>';
			}
		})
    	// ==========================================

    	var buttonLoadMorePosts = document.querySelector("[component='topic'][data-tid='"+tid+"'] .showMorePosts");
    	if(buttonLoadMorePosts!=null){
    		buttonLoadMorePosts.addEventListener('click', function(){
	    		data = {}
	    		data.topics = {}
	    		socket.emit('plugins.connectHomepage.homepage.getNewTopicPrivilege', {tid:tid}, function(err, privileges) {
					data.topics.privileges = privileges
		    		socket.emit('plugins.connectHomepage.homepage.topicOthersPosts', {tid:tid}, function(err, posts) {
		                if (err) {
		                    app.alertError(err.message);
		                    return false;
		                }
		                posts.forEach(post => {
		                	var pid = post.pid;
		                	app.parseAndTranslate('connect-homepage/partials/post', {posts: post, topics: data.topics}, function(tpl) {
			                	var topicContainer = components.get('topic', 'tid', tid);
			               
					        	topicContainer.find('.posts .post-stream .scroller').prepend(tpl);
					        	var postContainer = components.get('post', 'pid', pid);
					        	postContainer.find('.timeago').timeago();
			            	});
		                })
		                return true;
		            });

		    	});
		    	this.classList.add('hidden');
	    	});
    	}
	}

	function topicNew(data) {
		socket.emit('plugins.connectHomepage.homepage.checkNewTopic', {topic:data.topic, type:connectHomepage.type, theirid: connectHomepage.theirid}, function(err, topicData) {
			if(topicData) {
				if (connectHomepage.view !== 'category'){
					$(window).trigger('action:topics.loaded', {topics: topicData.topicData});
					app.parseAndTranslate('connect-homepage/partials/topic', {topics:topicData.topicData}, function(html) {
						document.querySelector('.topics').prepend(html[0]);
						html.find('.timeago').timeago();
						topicInit(topicData.topicData.tid);
						app.createUserTooltips();
					});
				} else {
					$(window).trigger('action:topics.loaded', {topics: topicData.topicData});
					app.parseAndTranslate('connect/partials/topic/topics_list_item', {topics:topicData.topicData}, function(html) {
						$('#category-no-topics').remove();
						$('[component="category"]').append(html);
						html.find('.timeago').timeago();
						app.createUserTooltips();
						utils.makeNumbersHumanReadable(html.find('.human-readable-number'));
						html.find('img').attr('data-state', 'loaded');
						$(window).trigger('action:ajaxify.end', topicData)
					});
				}
				
			}
		});
	}

	return connectHomepage;
});
